<template>
    <div class="view">
        <div class="text-center">
            <b-form-group>
                <b-form-radio-group
                        v-model="currentSubpage"
                        name="radios-btn-default" :buttons="true" @input="navigate(currentSubpage)">
                    <b-form-radio v-for="route in visibleSubpage"
                                  :value="route"
                                  :key="route.name">
                        {{route.meta.title ? route.meta.title : route.name}}
                    </b-form-radio>
                </b-form-radio-group>
            </b-form-group>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
  import hasPermission from "../filters/hasPermission";

  export default {
    name: "SubPages",
    props: ['parentRoute'],
    data() {
      return {
        currentSubpage: null,
      }
    },
    watch: {
      $route(to) {
        if (this.currentSubpage != null && to.name !== this.currentSubpage.name) {
          this.currentSubpage = null;
        }
      }
    },
    mounted() {
      for (const page of this.visibleSubpage) {
        if (page.name === this.$route.name) {
          this.currentSubpage = page;
        }
      }
      if (!this.currentSubpage) {
        this.currentSubpage = this.visibleSubpage[0];
      }
    },
    computed: {
      visibleSubpage() {
        return this.parentRoute.children.filter(child => hasPermission(child.meta.allowedRoles) && !child.meta.hideFromSubpages);
      }
    },
    methods: {
      navigate(route) {
        if (route) {
          this.$router.push(this.parentRoute.path + '/' + route.path);
        }
      }
    }
  }
</script>
